import { ReactNode, useState } from "react";

import { Button, Modal } from "react-bootstrap";

import Carousel from "react-bootstrap/Carousel";

import illustrationLanding1 from "../../../assets/img/illustration-landing-1.png";
import illustrationLanding2 from "../../../assets/img/illustration-landing-2.png";
import history from "../../../routes/history";

export const ModalFirstLogin = ({ isShow }: { isShow: boolean }) => {
  const [show, setShow] = useState(isShow);
  const [indexFrame, setIndexFrame] = useState(0);

  const handleClose = () => setShow(false);

  const handleSlideLeft = () => setIndexFrame((indexFrame - 1 + 3) % 3);

  const handleSlideRight = () => setIndexFrame((indexFrame + 1) % 3);

  return (
    <Modal show={show} size="lg" centered>
      <div className="my-5">
        <Carousel
          className="carousel-inner"
          interval={null}
          controls={false}
          indicators={false}
          activeIndex={indexFrame}
        >
          <Carousel.Item>
            <Frame title="Bienvenue !" image={illustrationLanding1}>
              dwell est un logiciel de services pour les pros de l'immobilier.
              <br />
              <br />
              Il est différent des logiciels métiers traditionnels et
              application d'état des lieux car il vous permet de gérer en
              autonomie ou déléguer certains services de votre parcours
              locataire : EDL, ERP, Diagnostic....
              <br />
              <br />
              Il vous aide à louer plus vite et à en prendre soins des biens que
              vous gérez !
            </Frame>
          </Carousel.Item>
          <Carousel.Item>
            <Frame
              title="La fin des emails et appels inutiles"
              image={illustrationLanding2}
            >
              Passez vos commandes en 1 clic ou en quelques secondes :
              <br />
              <br />
              <ul>
                <li>Choisissez la prestation</li>
                <li>Ajoutez un bien</li>
              </ul>
              ... Ou en important votre portefeuille de biens gérés dans votre
              espace.
            </Frame>
          </Carousel.Item>
          <Carousel.Item>
            <Frame title="Nous sommes là pour vous aider !">
              Avec l'application vous trouverez une équipe et des ressources
              pour vous aider :
              <br />
              <br />
              <ul>
                <li>Centre d'aide et infothèque</li>
                <li>Un gestionnaire de compte dédié</li>
              </ul>
            </Frame>
          </Carousel.Item>
        </Carousel>
        <div className="d-flex justify-content-between mx-5 mt-5">
          {indexFrame === 0 ? (
            <Button variant="secondary" onClick={handleClose}>
              Ignorer
            </Button>
          ) : (
            <Button variant="outline-primary" onClick={handleSlideLeft}>
              Retour
            </Button>
          )}

          <div className="d-flex align-items-center">
            <div
              className={
                "carousel-indicator " + (indexFrame === 0 && "bg-primary")
              }
              onClick={() => setIndexFrame(0)}
            ></div>
            <div
              className={
                "carousel-indicator " + (indexFrame === 1 && "bg-primary")
              }
              onClick={() => setIndexFrame(1)}
            ></div>
            <div
              className={
                "carousel-indicator " + (indexFrame === 2 && "bg-primary")
              }
              onClick={() => setIndexFrame(2)}
            ></div>
          </div>

          {indexFrame === 2 ? (
            <Button
              variant="primary"
              onClick={() => {
                handleClose();
                history.push("/new-order");
              }}
            >
              Créer ma 1ère commande
            </Button>
          ) : (
            <Button variant="primary" onClick={handleSlideRight}>
              Suivant
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

const Frame = ({
  title,
  image,
  children,
}: {
  title: string;
  image?: string;
  children: ReactNode;
}) => {
  return (
    <div className="d-block w-100">
      <div className="d-flex flex-column justify-content-center">
        <h2 className="text-success mb-4 mx-5">{title}</h2>
        {image ? (
          <div className="row">
            <div className="col-sm-8">
              <p className="dark-purple-text mx-5">{children}</p>
            </div>
            <div className="col-sm-4 d-none d-sm-block">
              <img src={image} alt="landing" />
            </div>
          </div>
        ) : (
          <p className="dark-purple-text mx-5">{children}</p>
        )}
      </div>
    </div>
  );
};
